module.exports = __webpack_public_path__ + "static/media/white_heart.fd1f8fa8.svg";